import { render, staticRenderFns } from "./zhuzhuangtu.vue?vue&type=template&id=74d1bd64&"
import script from "./zhuzhuangtu.vue?vue&type=script&lang=js&"
export * from "./zhuzhuangtu.vue?vue&type=script&lang=js&"
import style0 from "./zhuzhuangtu.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports